import { Button, Stack, Typography } from '@mui/material'
import { FC } from 'react'

import { useRouter, useTranslation } from '@/core'

type MembershipJoinedModalProps = {
  artistId: string
}

export const MembershipJoinedModal: FC<MembershipJoinedModalProps> = ({
  artistId,
}) => {
  const { router, routerPages, generatePath } = useRouter()
  const { t } = useTranslation('membershipJoinedModal')

  const onClose = (): void => {
    router.replace(generatePath(routerPages.ArtistMembership, { artistId }))
  }

  return (
    <>
      <Stack sx={{ maxWidth: 600, width: '100%', margin: '0 auto' }}>
        <Stack sx={{ pt: 5 }} />
        <Stack sx={{ p: 7, mt: 6 }} alignItems="center">
          <Typography variant="h4">
            {t('title', 'メンバーシップに加入済みです')}
          </Typography>
          <Typography variant="body1" sx={{ pt: 2 }}>
            {t(
              'message',
              '既に加入中のプランがあります。プランを変更する場合は、プランのアップグレードまたはダウングレードを行ってください。'
            )}
          </Typography>
        </Stack>
        <Stack alignItems="center">
          <Button onClick={onClose} size="large">
            {t('confirm', 'プランを選択する')}
          </Button>
        </Stack>
      </Stack>
    </>
  )
}
